import React from 'react';
import './RegularProgressBar.css';

export default function regularProgressBar(props) {
    return (
        <div className="skill">
            <div>
                <span className="regular-white-text">{props.name}</span>
                <span className="regular-white-text">{props.precentage}</span>
            </div>
            <li>
                <span className="coding-skill-bar">
                    <span className={props.class} style={{width: props.precentage}}></span>
                </span>
            </li>
        </div>
    )
}
